'use client';

import Reveal from "@/components/animation/reveal";

export default function StoriesHeading({ text, title }) {
  return (
    <Reveal className="grid-4 mx-auto">
      <div className="col-span-full text-center max-w-130 mx-auto lg:max-w-148.5 lg:col-span-full xl:pt-9">
        <h1 className="heading-1-small text-center xl:heading-1">{title}</h1>
        <p className="body-1-small text-center text-pretty mt-10 lg:mt-14 xl:body-1">{text}</p>
      </div>
    </Reveal>
  );
}
